import styled, { css } from "styled-components";

export const StyledButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  height: 35px;
  line-height: 35px;
  border: 2px solid #f3f1a5;
  font-size: 16px;
  font-family: var(--font-mono);
  font-weight: 700;
  text-transform: uppercase;
  color: #002B43;
  background: #FFFFFF;
  padding: 0 18px;
  border-radius: 20px;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
  }

  &:hover {
    background: #f3f1a5;
  }

  ${(props) =>
    props.img &&
    css`
      svg {
        display: none;
      }
    `}

  @media (min-width: 640px) {
    
    &:hover {
      ${(props) =>
        props.img &&
        css`
          svg {
            display: none;
          }
          .selected {
            display: block;
          }
        `}
    }
    ${(props) =>
      props.img &&
      css`
        background: none !important;
        border: none !important;
        box-shadow: none !important;
        padding: 0 2rem;
        margin-right: -0.125rem !important;

        svg {
          position: absolute;
          z-index: -1;
          top: 0;
          left: 0px;
          height: 100%;
          display: block;

          &.selected {
            display: none;
          }
        }
      `}

    ${(props) =>
      props.img && props.isActive &&
      css`
        svg {
          display: none;
        }
        svg.selected {
          display: block;
        }
      `}
  }

  ${(props) =>
    props.isActive &&
    css`
      background: #f3f1a5;
    `}

  ${(props) =>
    props.type === "dark" &&
    css`
      border-color: #51B0E3;

      &:hover {
        background: #51B0E3;
      }
    `}
  ${(props) =>
    props.type === "dark" &&
    props.isActive &&
    css`
      background: #51B0E3;
    `}

  ${(props) =>
    props.type === "light" &&
    css`
      font-family: var(--font-mono);
      font-weight: 700;
      font-size: 16px;
      text-transform: uppercase;
      border-width: 2px;
    `}

  ${(props) =>
    props.type === "blue" &&
    css`
      border-width: 2px;
      border-color: var(--color-tertiary);

      &:hover {
        background: var(--color-tertiary);
      }
    `}
  ${(props) =>
    props.type === "blue" &&
    props.isActive &&
    css`
      background: var(--color-tertiary);
    `}

  ${(props) =>
    props.size === "small" &&
    css`
      height: 28px;
      line-height: 28px;
      font-size: 13px;
      padding: 0 12px;
    `}
`;
